var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 12C10 9.79089 11.7909 8 14 8C16.2091 8 18 9.79089 18 12C18 14.2091 16.2091 16 14 16C11.7909 16 10 14.2091 10 12ZM14 9.5C12.6193 9.5 11.5 10.6193 11.5 12C11.5 13.3807 12.6193 14.5 14 14.5C15.3807 14.5 16.5 13.3807 16.5 12C16.5 10.6193 15.3807 9.5 14 9.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8C6.44772 8 6 8.44772 6 9C6 9.55228 6.44772 10 7 10C7.55228 10 8 9.55228 8 9C8 8.44772 7.55228 8 7 8Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33192 3.96032C4.85437 3.3508 5.61708 3 6.41987 3H7.93431C8.49543 3 9.03356 3.2229 9.43033 3.61967C9.67385 3.86319 10.0041 4 10.3485 4H18.25C20.3211 4 22 5.67894 22 7.75V16.25C22 18.3211 20.3211 20 18.25 20H5.75C3.67894 20 2 18.3211 2 16.25V7.75C2 6.3668 2.74909 5.15966 3.86058 4.51021L4.33192 3.96032ZM6.41987 4.5C6.05497 4.5 5.70828 4.65946 5.4708 4.93651L4.9126 5.58774C4.85168 5.6588 4.77801 5.71784 4.69537 5.76179C3.98259 6.14093 3.5 6.88969 3.5 7.75V16.25C3.5 17.4927 4.50736 18.5 5.75 18.5H18.25C19.4927 18.5 20.5 17.4927 20.5 16.25V7.75C20.5 6.50736 19.4927 5.5 18.25 5.5H10.3485C9.6063 5.5 8.89449 5.20515 8.36967 4.68033C8.2542 4.56486 8.09761 4.5 7.93431 4.5H6.41987Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera4);
export default __webpack_public_path__ + "static/media/camera-4.f687585aa52bec8a2ed1a723427ac913.svg";
export { ForwardRef as ReactComponent };